<div class="subtitle" *ngIf="displayTable">{{ subtitleWidget }}</div>
<div *ngIf="requestState">
    <div style="margin: 0 1.5em" *ngIf="displayTable">
        <table
            class="mt-table mt-table-striped"
            style="margin-bottom: 30px"
            aria-label="table-status-machine"
        >
            <thead>
                <tr>
                    <th scope="col">{{ "machine" | lang }}</th>
                    <th scope="col">{{ "loop" | lang }}</th>
                    <th scope="col">{{ "last_transit_in" | lang }}</th>
                    <th scope="col">{{ "last_transit_out" | lang }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of originalData">
                    <td>{{ data.machineName }}</td>
                    <td>{{ data.loops }}</td>
                    <td>{{ data.lastInTransit | fullDateTimePresentation }}</td>
                    <td>
                        {{ data.lastOutTransit | fullDateTimePresentation }}
                    </td>
                </tr>
            </tbody>
        </table>
        <div></div>
    </div>
</div>
